import React from "react";
import { ebokContactService } from "../../Services/ebokContactService";
import ContactScreenBase from "../../common/screens/ContactScreenBase/ContactScreenBase";

const ContactScreen = () => {
  return <ContactScreenBase service={ebokContactService} />;
};

export default ContactScreen;
